import { isNull, isUndefined } from "lodash";

export default (v) => {
  if (isNull(v) || isUndefined(v)) return false;
  return `${v}`.length > 0;
};
